import styles from './styles.module.scss'
import Container from '../../elements/Container'
import { useResponsive } from '../../../providers/ResponsiveContext'
import { withModifiers } from '../../helpers/withModifiers'
import LazyImage from '../../elements/LazyImage'

const GalleryGrid = ({ button, images, variant = [] }) => {
  const { isDesktop } = useResponsive()

  // Helper function to get image URLs based on Cloudflare variants
  const getImageUrls = (item) => {
    const baseUrl = item.large || item.original || item
    const isCloudflare =
      typeof baseUrl === 'string' && baseUrl.includes('imagedelivery.net')

    // Use standard size variants for all images since they're all above the fold
    const getVariant = (size) => {
      if (!isCloudflare) return baseUrl
      return baseUrl.replace(/\/([^/]+)$/, `/${size}`)
    }

    return {
      small: getVariant('360'),
      medium: getVariant('640'),
      large: getVariant('960')
    }
  }

  return (
    <div
      className={withModifiers(
        'gallery',
        [...variant, button && 'has-button'],
        styles
      )}
    >
      <div className={styles.gallery__grid}>
        {images &&
          images.map((item, index) => {
            if (!item) return null
            const urls = getImageUrls(item)

            return (
              <div key={index} className={styles.gallery__item}>
                <LazyImage
                  fetchpriority="high"
                  srcSet={`${urls.small} 360w,
                          ${urls.medium} 640w,
                          ${urls.large} 960w,
                          ${urls.large} 1980w`}
                  src={urls.large}
                  layout="fill"
                  priority
                  objectFit="cover"
                  sizes="(max-width: 360px) 360px, (max-width: 640px) 640px, (max-width: 960px) 960px, 960px"
                  alt={`Gallery Image ${index}`}
                  className={styles.gallery__image}
                />

                {index === 1 && !isDesktop && button && button}
              </div>
            )
          })}
      </div>
      {isDesktop && button && <Container>{button}</Container>}
    </div>
  )
}

export default GalleryGrid
